module.exports = __webpack_public_path__ + "img/AL273LS-2-EN.922b59e7.jpg";